<template>
  <div class="w-full h-full flex flex-col justify-center items-center" :data-ui="'preview-page' + activePageId">
    <div class="w-full h-full flex flex-col items-center justify-center">
      <span v-if="marktNumber" class="font-bold text-xl p-2">Marktnummer: {{ marktNumber }}</span>
      <div class="p-2 bg-primary text-2xl" v-if="!activePageId">
        <span>Keine Vorschau</span>
      </div>
      <div class="w-full h-full flex items-center gap-2 justify-center">
        <!-- Verbesserte Navigation -->
        <button v-if="showPages" @click="prevPage"
                class="w-[50px] h-[80px] bg-trader-gray flex items-center justify-center rounded hover:bg-opacity-90 transition-colors shadow-md">
          <i class="fa-solid fa-arrow-left text-xl"></i>
        </button>

        <object
            v-if="activePageId"
            class="w-full h-full"
            type="image/svg+xml"
            rel="pagePreview"
            :data="previewUrl"
            :style="styleObject">
          <param name="type" value="image/svg+xml">
        </object>

        <button v-if="showPages" @click="nextPage"
                class="w-[50px] h-[80px] bg-trader-gray flex items-center justify-center rounded hover:bg-opacity-90 transition-colors shadow-md">
          <i class="fa-solid fa-arrow-right text-xl"></i>
        </button>
      </div>
    </div>
    <div class="flex flex-col gap-2" v-if="showPages">
      <div class="w-full grid grid-cols-12 gap-2 p-2 overflow-auto  ">
        <div class="p-2 min-w-[50px] text-center cursor-pointer"
             @click="selectPage(page?.id, index + 1)"
             v-for="(page, index) in pages"
             :key="page?.id"
             :class="parseInt(page?.name) === parseInt(activePagePosition) ? 'bg-trader-blue text-white font-medium' : 'bg-trader-gray'">
          {{ page?.name }}
        </div>
      </div>
      <div v-if="activeMarketId" class="grid grid-cols-12 gap-2 p-2 overflow-auto w-full">
        <div class="p-2 min-w-[50px] text-center cursor-pointer"
             @click="selectMarket(market.marketId)"
             v-for="market in markets"
             :key="market.marketId"
             :class="parseInt(market.marketId) === parseInt(activeMarketId) ? 'bg-trader-blue text-white font-medium' : 'bg-trader-gray'">
          {{ market?.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import {query} from "@/graphql";

export default {
  props: {
    value: {type: Object, default: () => ({})},
    pageId: {type: Number, default: 0},
    quality: {type: Number, default: 1},
    marktNumber: {type: String, default: ''},
    magazineId: {type: Number, default: 0},
    marketId: {type: Number, default: 0},
    showPages: {type: Boolean, default: true}
  },
  data() {
    return {
      styleObject: {},
      random: Math.random(),
      pages: [],
      activePageId: this.pageId || null,
      activeMarketId: this.marketId || 0,
      markets: [],
      currentMagazineId: this.magazineId,
      activePagePosition: 0 // 1-basierter Index der Seite
    };
  },
  computed: {
    ...mapState('settings', ['showNumbers', 'showNotes']),
    previewUrl() {
      if (!this.activePageId) return '';
      return `/api/v3/preview/page/${this.activePageId}?callback=page${this.activePageId}&random=${this.random}&show_numbers=${this.showNumbers}&show_notes=${this.showNotes}&clickable=false&quality=${this.quality}`;
    }
  },
  methods: {
    async fetchPages() {
      const [data, err] = await query.getPagesWithIdAndName(this.currentMagazineId);
      if (err) {
        console.error(err);
        return;
      }
      this.pages = data;
      if (!this.activePageId && this.pages.length) {
        this.activePageId = this.pages[0].id;
        this.activePagePosition = 1;
      } else if (this.activePageId) {
        const index = this.pages.findIndex(page => page.id === this.activePageId);
        if (index !== -1) {
          this.activePagePosition = index + 1;
        }
      }
    },
    async fetchMarkets() {
      const [data, err] = await query.getMarkets();
      if (err) {
        console.error(err);
        return;
      }
      this.markets = data;
    },
    async getPageWithIdAndNameBy() {


      const [data, err] = await query.getPageWithIdAndNameBy(this.currentMagazineId, this.activeMarketId, this.activePagePosition);
      if (err) {
        console.error(err);
        return;
      }
      if (data && data.length > 0) {
        this.activePageId = data[0].id;
        this.pagePosition = data[0]?.name;
      }
    },
    selectPage(pageId, position) {
      this.activePagePosition = position;
      if (this.activeMarketId !== 0) {
        this.getPageWithIdAndNameBy();
      } else {
        this.activePageId = pageId;
      }
    },
    selectMarket(marketId) {
      this.activeMarketId = marketId;
      this.getPageWithIdAndNameBy();
    },
    prevPage() {
      const currentIndex = this.pages.findIndex(page => page.id === this.activePageId);
      if (currentIndex > 0) {
        const newPage = this.pages[currentIndex - 1];
        this.activePageId = newPage.id;
        this.activePagePosition = currentIndex; // vorherige Seite (1-basierter Wert)
        if (this.activeMarketId !== 0) {
          this.getPageWithIdAndNameBy();
        }
      }
    },
    nextPage() {
      const currentIndex = this.pages.findIndex(page => page.id === this.activePageId);
      if (currentIndex < this.pages.length - 1) {
        const newPage = this.pages[currentIndex + 1];
        this.activePageId = newPage.id;
        this.activePagePosition = currentIndex + 2; // nächste Seite (1-basierter Wert)
        if (this.activeMarketId !== 0) {
          this.getPageWithIdAndNameBy();
        }
      }
    },
    setupPreviewCallback() {
      window.crossApi = window.crossApi || {};
      window.crossApi.callbacks = window.crossApi.callbacks || {};
      window.crossApi.callbacks['page' + this.activePageId] = (w, h) => {
        this.styleObject = {
          width: `${w}px`,
          height: `${h}px`
        };
      };
    }
  },
  watch: {
    activePageId() {
      this.setupPreviewCallback();
    },

    },
    created() {

      if (this.currentMagazineId === 0) {
         this.currentMagazineId = this.$route.params.magazineId;

      }
    },
    async mounted() {

      if (this.showPages) {
        await this.fetchPages();
        await this.fetchMarkets();
        this.activePagePosition = this.pages.find(page => page.id === this.activePageId)?.name;
      }
      this.setupPreviewCallback();


    }
  }
</script>
